import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { popperVariation, provideTippyConfig, provideTippyLoader, tooltipVariation } from '@ngneat/helipopper/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import { providePrimeNG } from 'primeng/config';
import { AppTemplateModule } from 'src/modules/app-template/app-template.module';
import { Config } from 'src/modules/app-template/models/config.model';
import { MainFrontendConfig } from 'src/modules/app-template/netgen/MainFrontendConfig';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';

import { DevModule } from 'src/modules/dev/dev.module';









import { PrimeModule } from 'src/modules/prime/prime.module';

import { RungisSupplierModule } from 'src/modules/rungis-supplier/rungis-supplier.module';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { SmBaseModule } from 'src/modules/sm-base/sm-base.module';

import { Utils } from 'src/modules/utils/shared/utils';
import { AppRoutes } from './app.routes';

export function init_app(app: MainAppService) {
    return async () => {
        await app.auth.updateUserDetails();
        app.mainConfig = await RestEndpoint.main().find().run("api/app/mainConfig").get(MainFrontendConfig); 

        ModuleRegistry.registerModules([AllCommunityModule]);
        
        if (!Utils.isNoe(Config.get().agGridEnterpriseKey)) {
            ModuleRegistry.registerModules([AllEnterpriseModule]);
            LicenseManager.setLicenseKey(Config.get().agGridEnterpriseKey);
        }
        
        provideGlobalGridOptions({ theme: "legacy"});

        await app.setLanguage(null);

        await app.featureModules.beforeAppStart();
    };
}

@NgModule({ imports: [
        BrowserModule,
        PrimeModule,
        AppTemplateModule,
        AppRoutes,
        
        
        
        
        
        
        
        
        
        DevModule,
        RungisSupplierModule,
        
        
        
        SmBaseModule /*, TODO Kann wieder aktiviert werden, wenn der Worker dann wirklich implementiert ist
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: Config.get().production })*/], providers: [
        provideAppInitializer(() => {
            const initializerFn = init_app(inject(MainAppService));
            return initializerFn();
        }),
        provideTippyLoader(() => import('tippy.js')),
        provideTippyConfig({
            defaultVariation: 'tooltip',
            variations: {
                tooltip: {
                    ...tooltipVariation,            
                    theme: 'light'
                },
            },
        }),
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: { 
                preset: definePreset(Aura, Config.get().getPrimePreset()),
                options: {
                    darkModeSelector: '.dark-mode'
                }
            }
        })
    ] })
export class AppModule {

    app = inject(MainAppService);

    constructor() {
        this.app.appName = Config.get().pageTitle;
        this.app.pageTitle = this.app.appName;
    }
}